<template>
  <v-app class="animated-resize">
    <v-row class="justify-md-center">
      <v-col cols="12" :md="6" :lg="5" class="mt-0 pt-0 mt-md-8">
        <v-card>
          <div class="header-bar pa-4" height="80">
            <div class="d-flex align-center">
              <v-img
                alt="Logo"
                class="shrink mr-2"
                contain
                src="./assets/escudo45x55.gif"
                transition="scale-transition"
                width="40"
              />

              <span class="header-title">Firmador de Documentos</span>
            </div>

            <v-spacer></v-spacer>
          </div>
          <v-content>
            <router-view></router-view>
          </v-content>
        </v-card>
      </v-col>
    </v-row>
  </v-app>
</template>

<script>
export default {
  name: "App",

  components: {},

  data: () => ({
    //
  })
};
</script>

<style lang="scss">
.header-bar {
  background-color: #2b2d42;
}

.header-title {
  color: white;
  font-size: 20px;
  font-weight: 400;
}

.round-header-title {
  border-radius: 15 15 0 0;
}
.animated-resize {
  transition: all 3s;
}
</style>
